import axios from "axios";

export const setupAxiosInterceptors = (navigate) => {
  axios.interceptors.request.use((config) => {
    const session = sessionStorage.getItem("authSession");
    const authData = session ? JSON.parse(session) : null;
    const token = authData?.jwt_token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        sessionStorage.removeItem("authSession");

        if (navigate) navigate("/login");
        else window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
};
